export default "__VITE_ASSET__D8zYm8Wh__"